/**
 * Submission list component.
 *
 * @module SubmissionList
 */

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { UserSubmission } from './types';
import { SubmissionListItem } from './SubmissionListItem';

interface SubmissionListProps {
  readonly submissions: UserSubmission[];
  readonly total: number;
  readonly onPreviewSubmission: (submission: UserSubmission, module: string) => void;
  readonly onDelete: (submission: UserSubmission) => void;
  readonly deletingSessionId: string | null;
  readonly loadingReviewKey: string | null;
}

export function SubmissionList({
  submissions,
  total,
  onPreviewSubmission,
  onDelete,
  deletingSessionId,
  loadingReviewKey,
}: Readonly<SubmissionListProps>) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="font-ui">
          Submissions ({total})
        </CardTitle>
      </CardHeader>
      <CardContent>
        {submissions.length === 0 ? (
          <Alert>
            <AlertDescription className="font-ui">
              No submissions found
            </AlertDescription>
          </Alert>
        ) : (
          <div className="space-y-3">
            {submissions.map((submission) => (
              <SubmissionListItem
                key={`${submission.session_id}-${submission.user_id}`}
                submission={submission}
                onPreviewSubmission={onPreviewSubmission}
                onDelete={onDelete}
                isDeleting={deletingSessionId === submission.session_id}
                loadingReviewKey={loadingReviewKey}
              />
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
